/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Err_Note_Too_LongInputs */

const vi_einvoice_err_note_too_long = /** @type {(inputs: Einvoice_Err_Note_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ghi chú tối đa 500 ký tự`)
};

/**

* @param {Einvoice_Err_Note_Too_LongInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_err_note_too_long = /** @type {((inputs?: Einvoice_Err_Note_Too_LongInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Err_Note_Too_LongInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_err_note_too_long(inputs)
});